export enum IMPORT_STATE {
  NOT_STARTED = 0,
  IMPORTING = 1,
  FINISHED = 2,
}

export const SCRAPER_NAME = {
  AmazonReviewByUrl: 'amazon-review-by-url',
  AmazonReviewByUrlJP: 'amazon-review-by-url-jp',
  CoupangReview: 'coupang-review',
  DcinsidePost: 'dcinside-post',
  FacebookCommentByKeyword: 'facebook-comment-by-keyword',
  FacebookPrivateGroup: 'facebook-private-group',
  FacebookCommentByUrl: 'facebook-comment-by-url',
  FmkoreaPost: 'fmkorea-post',
  GoogleMapReviewByUrl: 'google-map-review-by-url',
  GoogleNews: 'google-news',
  InstagramCommentByKeyword: 'instagram-comment-by-keyword',
  InstagramCommentByProfile: 'instagram-comment-by-profile',
  InstagramReelsByKeywordForSyncly: 'instagram-reels-by-keyword-for-syncly',
  LazadaReview: 'lazada-review',
  NaverBlogPost: 'naver-blog-post',
  NaverCafeAccountBase: 'naver-cafe-account-base',
  NaverCafeAllSearch: 'naver-cafe-all-search',
  NaverCafeInSearch: 'naver-cafe-in-search',
  NaverSpecificCafeSearch: 'naver-specific-cafe-search',
  NaverStoreReviewByUrl: 'naver-store-review-by-url',
  OliveyoungReview: 'oliveyoung-review',
  PpomppuPost: 'ppomppu-post',
  Qoo10Review: 'qoo10-review',
  RedditPostByKeyword: 'reddit-post-by-keyword',
  SephoraReview: 'sephora-review',
  ShopeeReview: 'shopee-review',
  ThriveMarketReview: 'thrivemarket-review',
  TiktokCommentByKeywordForSyncly: 'tiktok-comment-by-keyword-for-syncly',
  TiktokCommentByProfile: 'tiktok-comment-by-profile',
  TiktokPostByKeywordForSyncly: 'tiktok-post-by-keyword-for-syncly',
  YoutubeShortsByKeywordForSyncly: 'youtube-shorts-by-keyword-for-syncly',
  TiktokPostByProfile: 'tiktok-post-by-profile',
  TwitterPostByKeyword: 'twitter-post-by-keyword',
} as const;

export type SCRAPER_NAME = (typeof SCRAPER_NAME)[keyof typeof SCRAPER_NAME];

export const SCRAPER_DOMAIN_NAME = {
  youtubeShorts: 'short',
};
